<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: 'BaseBusinessContact',

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },

  data: () => ({
    business: [
      {
        icon: 'mdi-briefcase-clock',
        title: 'Opening Hours',
        text: 'Monday - Friday, 08:00 - 17:00. <br>Fridays doors close at 16:00.',
      },
      {
        icon: 'mdi-map-marker-outline',
        title: 'Address',
        text: 'Gants Centre, 26 Potgieter St, Strand, Cape Town, 7140, South Africa',
      },
      {
        icon: 'mdi-cellphone',
        title: 'Phone',
        text: 'Need advice? Want to make an appointment? <br>+27 (21) 853 6066',
      },
      {
        icon: 'mdi-email',
        title: 'Email',
        text: 'We always respond! <br>helderbergpropshaft@gmail.com',
      },
    ],
  }),
};
</script>
